////
/// ============================================================================
/// COMPONENT / Details Filters
/// ============================================================================
///
/// @group components
////

import debounce from "../utils/debounce.js";

export default () => {
    let details = document.querySelector(".js-details-filters");

    if (!details) {
        return;
    }

    let layout = getLayout();

    function getLayout() {
        return getComputedStyle(details).getPropertyValue('--layout')
            // trim "desktop" -> desktop
            .replace(/^"|"$/g, "");
    }

    function handle(layout) {
        if ("desktop" === layout) {
            details.setAttribute("open", "open");
        } else {
            details.removeAttribute("open");
        }
    }

    handle(layout);

    window.addEventListener('resize', debounce(() => {
        let newLayout = getLayout();

        if (layout !== newLayout) {
            layout = newLayout;
            handle(newLayout);
        }
    }));
};
